// src/pages/NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="notfound-page">
      <h1>404</h1>
      <p>Página no encontrada.</p>
      <Link to="/">Volver al Dashboard</Link>
      <style jsx="true">{`
        .notfound-page { text-align: center; padding: 80px 20px; }
        .notfound-page h1 { font-size: 5rem; color: #3498db; }
        .notfound-page p { font-size: 1.2rem; }
        a { color: #3498db; text-decoration: none; font-weight: bold; }
        a:hover { text-decoration: underline; }
      `}</style>
    </div>
  );
}

export default NotFound;
